import { render } from "./RTextarea.vue?vue&type=template&id=0c106c34"
import script from "./RTextarea.vue?vue&type=script&lang=js"
export * from "./RTextarea.vue?vue&type=script&lang=js"

import "./RTextarea.vue?vue&type=style&index=0&id=0c106c34&lang=css"
script.render = render

export default script